import createActions from "helpers/actionCreator"
import { call, put, takeLatest } from "redux-saga/effects"
import { Creators as notificationCreators } from "modules/notifications/model"
import { get as apiGet } from "api"
import { createReducer } from "reduxsauce"

const EMPTY_ARRAY = []
// `createActions` is use to create both action types and creators.
// First param is the action prefix (without a finishing /)
// Second param is a list of action to create, with a list of parameters.
export const { Types, Creators } = createActions("ompnt/modules/tokens", {
  openTokenFeatures: ["tokenId"],
  setTokenFeatures: ["features"],
})

// Action handlers would go here, for example:
const DEFAULT_STATE = {
  tokenFeatures: EMPTY_ARRAY,
  tokenFeaturesLoading: false,
}

function handleSetTokenFeatures(state, { features }) {
  return { ...state, tokenFeatures: features, tokenFeaturesLoading: false }
}

function handleOpenTokenFeatures(state) {
  return { ...state, tokenFeaturesLoading: true }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_TOKEN_FEATURES]: handleSetTokenFeatures,
  [Types.OPEN_TOKEN_FEATURES]: handleOpenTokenFeatures,
})

function* loadTokenFeatures({ tokenId }) {
  try {
    const features = yield call(apiGet, `/api/admin/tokens/${tokenId}/features`)
    yield put(Creators.setTokenFeatures(features))
  } catch {
    const error = "An unknown error occurred while fetching the token features."
    yield put(notificationCreators.add("error", null, error))
  }
}

// All functions named `saga` are automatically loaded by the saga manager in `new/model/saga.js`
export function* saga() {
  yield takeLatest([Types.OPEN_TOKEN_FEATURES], loadTokenFeatures)
}
